/**
 * Application constants
 *
 * This file defines constants used throughout the application.
 */

// Document types supported by the Vault domain
export enum DocumentType {
  PDF = 'pdf',
  DOCX = 'docx',
  XLSX = 'xlsx',
  PPTX = 'pptx',
  DOC = 'doc',
  TXT = 'txt',
  MD = 'md',
  CSV = 'csv',
  ZIP = 'zip',
  PNG = 'png',
  JPG = 'jpg',
  GIF = 'gif',
  XLS = 'xls',
  XLSB = 'xlsb',
  XLSM = 'xlsm',
  ODS = 'ods',
  DWG = 'dwg',
  STL = 'stl',
  SPC = 'spc',
  // Future support for design files
  DESIGN = 'design',
}

// Content types for documents
export const CONTENT_TYPES = {
  [DocumentType.PDF]: 'application/pdf',
  [DocumentType.DOCX]:
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  [DocumentType.XLSX]:
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  [DocumentType.PPTX]:
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  [DocumentType.DOC]: 'application/msword',
  [DocumentType.TXT]: 'text/plain',
  [DocumentType.MD]: 'text/markdown',
  [DocumentType.CSV]: 'text/csv',
  [DocumentType.ZIP]: 'application/zip',
  [DocumentType.PNG]: 'image/png',
  [DocumentType.JPG]: 'image/jpeg',
  [DocumentType.GIF]: 'image/gif',
  [DocumentType.XLS]: 'application/vnd.ms-excel',
  [DocumentType.XLSB]: 'application/vnd.ms-excel.sheet.binary.macroEnabled.12',
  [DocumentType.XLSM]: 'application/vnd.ms-excel.sheet.macroEnabled.12',
  [DocumentType.ODS]: 'application/vnd.oasis.opendocument.spreadsheet',
  [DocumentType.DWG]: 'application/octet-stream',
  [DocumentType.STL]: 'application/octet-stream',
  [DocumentType.SPC]: 'application/octet-stream',
  [DocumentType.DESIGN]: 'application/octet-stream',
};

// Pagination defaults
export const PAGINATION = {
  DEFAULT_PAGE_SIZE: 10,
  MAX_PAGE_SIZE: 100,
};

// API request timeouts (in milliseconds)
export const API_TIMEOUTS = {
  DEFAULT: 10_000, // 10 seconds
  UPLOAD: 60_000, // 60 seconds for uploads
};

// Local storage keys
export const STORAGE_KEYS = {
  AUTH_TOKEN: 'matic_auth_token',
  USER_PREFERENCES: 'matic_user_preferences',
};

// Error messages
export const ERROR_MESSAGES = {
  GENERIC: 'An error occurred. Please try again.',
  NETWORK: 'Network error. Please check your connection.',
  UNAUTHORIZED: 'You are not authorized to perform this action.',
  NOT_FOUND: 'The requested resource was not found.',
  VALIDATION: 'Please check your input and try again.',
};

// Date formats
export const DATE_FORMATS = {
  DISPLAY: 'MMM dd, yyyy',
  ISO: 'yyyy-MM-dd',
  DATETIME: 'MMM dd, yyyy HH:mm',
};

const constants = {
  DocumentType,
  CONTENT_TYPES,
  PAGINATION,
  API_TIMEOUTS,
  STORAGE_KEYS,
  ERROR_MESSAGES,
  DATE_FORMATS,
};

export default constants;
